import { render, staticRenderFns } from "./IsWatch.vue?vue&type=template&id=52a28bc0&scoped=true"
import script from "./IsWatch.vue?vue&type=script&lang=js"
export * from "./IsWatch.vue?vue&type=script&lang=js"
import style0 from "./IsWatch.vue?vue&type=style&index=0&id=52a28bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a28bc0",
  null
  
)

export default component.exports